import Vue from "vue";
import Router from "vue-router";

import {
  constantRouterMap
} from "@/config/router.config";

// hack router push callback
const originalPush = Router.prototype.push;
Router.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject)
    return originalPush.call(this, location, onResolve, onReject);
  return originalPush.call(this, location).catch(err => err);
};

Vue.use(Router);
const router = new Router({
  mode: "history",
  routes: constantRouterMap,
  getRouteByPath: function (path) {
    let resultRoute = null;

    resultRoute = __findRouteByPath(path, this.routes);

    return resultRoute;

    function __findRouteByPath(path, routes) {
      if (!routes || routes.length === 0) return null;

      let result = null;
      routes.some(function (item, index) {
        if (item.path.toLowerCase() === path.toLowerCase()) result = item;

        if (!result && !!item.children && item.children.length > 0)
          result = __findRouteByPath(name, item.children);

        return !!result;
      });
      return result;
    }
  }
});
export default router;



// WEBPACK FOOTER //
// ./src/router/index.js